"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _hooks = require("../../hooks");
var _CetComponentsProvider = require("../../providers/CetComponentsProvider");
const useStyles = props => {
  const {
    fontFamily,
    basicFontSize,
    themeColors,
    direction
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  const {
    pxToRem
  } = (0, _hooks.useStylesUtils)();
  const {
    isMobileView
  } = (0, _hooks.useDeviceData)();
  const ccDatePickerStyle = (0, _react.useMemo)(() => {
    const arrowStyleProps = () => ({
      borderColor: themeColors?.primary.main,
      borderWidth: `${pxToRem(2)} ${pxToRem(2)} 0 0`,
      width: pxToRem(6),
      height: pxToRem(6),
      top: pxToRem(9)
    });
    const deviceDayTitleProps = () => {
      const fontSize = isMobileView ? pxToRem(20) : pxToRem(14);
      return {
        fontSize
      };
    };
    const deviceDayNameProps = () => {
      const fontSize = isMobileView ? pxToRem(16) : pxToRem(12);
      const margin = isMobileView ? `${pxToRem(12)} ${pxToRem(14)} ${pxToRem(-2)}` : `${pxToRem(12)} ${pxToRem(8)} ${pxToRem(-2)}`;
      return {
        fontSize,
        margin
      };
    };
    const selectedDayStyle = () => ({
      color: themeColors?.primary.main,
      '&::after': {
        content: '""',
        border: `1px solid ${themeColors?.primary.main}`,
        boxSizing: 'border-box',
        display: 'block',
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: -1,
        borderRadius: '50%'
      }
    });
    const hoverDayStyle = () => ({
      color: themeColors?.general.light,
      '&::after': {
        content: '""',
        background: themeColors?.primary.main,
        boxSizing: 'border-box',
        display: 'block',
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: -1,
        borderRadius: '50%'
      }
    });
    const startDayStyle = () => ({
      color: themeColors?.primary.main,
      '&::after': {
        content: '""',
        background: themeColors?.general.light,
        border: `1px solid ${themeColors?.primary.main}`,
        boxSizing: 'border-box',
        display: 'block',
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: -1,
        borderRadius: '50%'
      },
      '&.react-datepicker__day': {
        '::before': {
          [direction === 'rtl' ? 'right' : 'left']: '50%',
          [direction === 'rtl' ? 'left' : 'right']: '0'
        }
      }
    });
    const endDayStyle = () => ({
      ...startDayStyle(),
      '&.react-datepicker__day': {
        '::before': {
          [direction === 'rtl' ? 'right' : 'left']: '0',
          [direction === 'rtl' ? 'left' : 'right']: '50%'
        }
      }
    });
    const innerDayStyle = () => ({
      '&::before': {
        content: '""',
        background: themeColors?.primary.light,
        display: 'block',
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: -2
      }
    });
    const dayStyleProps = date => {
      let style = {
        ...deviceDayTitleProps()
      };
      const {
        selectedDate
      } = props;
      const {
        startDate,
        endDate
      } = props;
      if (selectedDate && new Date(selectedDate).toDateString() === date.toDateString()) {
        style = {
          ...style,
          ...selectedDayStyle()
        };
        return style;
      }
      if (startDate && new Date(startDate).toDateString() === date.toDateString()) {
        style = {
          ...style,
          ...startDayStyle()
        };
        if (endDate && startDate < endDate) {
          style = {
            ...style,
            ...innerDayStyle()
          };
        }
        return style;
      }
      if (endDate && new Date(endDate).toDateString() === date.toDateString()) {
        style = {
          ...style,
          ...endDayStyle()
        };
        if (startDate && startDate < endDate) {
          style = {
            ...style,
            ...innerDayStyle()
          };
        }
        return style;
      }
      if (startDate && endDate) {
        if (startDate < date && date < endDate) {
          style = {
            ...style,
            ...innerDayStyle()
          };
        }
      }
      return style;
    };
    const ccDatePicker = (0, _css.css)({
      borderRadius: pxToRem(10),
      overflow: 'hidden',
      textAlign: 'center',
      '.react-datepicker': {
        fontFamily: fontFamily,
        border: 'none',
        borderRadius: 0,
        color: themeColors?.general.text,
        margin: 0,
        ...deviceDayTitleProps(),
        opacity: props.isDisabled ? 0.6 : 1,
        '.react-datepicker__header': {
          textAlign: 'center',
          backgroundColor: 'transparent',
          borderBottom: 'none',
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0
        },
        '.react-datepicker__current-month': {
          color: themeColors?.general.text,
          fontSize: basicFontSize
        },
        '.react-datepicker-time__header': {
          color: themeColors?.general.text,
          fontSize: basicFontSize
        },
        '.react-datepicker-year-header': {
          color: themeColors?.general.text,
          fontSize: basicFontSize
        },
        '.react-datepicker__year-read-view--down-arrow': {
          ...arrowStyleProps()
        },
        '.react-datepicker__month-read-view--down-arrow': {
          ...arrowStyleProps()
        },
        '.react-datepicker__month-year-read-view--down-arrow': {
          ...arrowStyleProps()
        },
        '.react-datepicker__navigation-icon::before': {
          ...arrowStyleProps()
        },
        '.react-datepicker__week': {
          position: 'relative',
          marginBottom: pxToRem(5),
          zIndex: 0
        },
        '.react-datepicker__day-names': {
          display: 'flex',
          justifyContent: 'space-between',
          ...deviceDayNameProps(),
          '.react-datepicker__day-name': {
            color: themeColors?.general.subText
          }
        },
        '.react-datepicker__month-text--keyboard-selected': {
          backgroundColor: 'transparent'
        },
        '.react-datepicker__quarter-text--keyboard-selected': {
          backgroundColor: 'transparent'
        },
        '.react-datepicker__year-text--keyboard-selected': {
          backgroundColor: 'transparent'
        },
        '.react-datepicker__day--disabled': {
          color: '#ccc'
        },
        '.react-datepicker__month-text--disabled': {
          color: '#ccc'
        },
        '.react-datepicker__quarter-text--disabled': {
          color: '#ccc'
        },
        '.react-datepicker__year-text--disabled': {
          color: '#ccc'
        }
      }
    });
    const ccDatePickerDay = date => {
      const daySize = isMobileView ? 45 : 32;
      return (0, _css.css)({
        '&.react-datepicker__day': {
          position: 'relative',
          color: themeColors?.general.text,
          borderRadius: 0,
          background: 'transparent',
          display: 'inline-flex',
          width: pxToRem(daySize),
          height: pxToRem(daySize),
          lineHeight: pxToRem(daySize),
          margin: 0,
          padding: 0,
          boxSizing: 'border-box',
          justifyContent: 'center',
          alignItems: 'center',
          ...dayStyleProps(date)
        },
        '&.react-datepicker__day--disabled': {
          opacity: 0.6
        },
        '&.react-datepicker__day:not(.react-datepicker__day--disabled):hover': {
          ...selectedDayStyle(),
          ...hoverDayStyle()
        }
      });
    };
    const ccDatePickerAnchorBtn = (0, _css.css)({
      display: 'flex',
      flexDirection: 'column',
      direction: 'ltr',
      lineHeight: 1,
      '& > div:nth-child(2)': {
        color: themeColors?.general.subText
      }
    });
    const deviceAnchorBtnProps = () => {
      const width = isMobileView ? '100%' : 'auto';
      return {
        width
      };
    };
    const ccRangeDatePickerAnchorBtn = (0, _css.css)({
      display: 'flex',
      flexDirection: 'row',
      width: '100%',
      '& > div': {
        margin: `0 ${pxToRem(7)}`,
        textAlign: 'center',
        lineHeight: 1,
        ...deviceAnchorBtnProps(),
        '& > div:nth-child(2)': {
          color: themeColors?.general.subText
        }
      },
      '& > div:nth-child(2)': {
        width: '1px',
        background: themeColors?.general.border
      }
    });
    return {
      ccDatePicker,
      ccDatePickerDay,
      ccDatePickerAnchorBtn,
      ccRangeDatePickerAnchorBtn
    };
  }, [basicFontSize, direction, fontFamily, isMobileView, props, pxToRem, themeColors?.general.light, themeColors?.general.subText, themeColors?.general.text, themeColors?.general.border, themeColors?.primary.light, themeColors?.primary.main]);
  return {
    'cc-DatePicker': ccDatePickerStyle.ccDatePicker,
    'cc-DatePicker__day': ccDatePickerStyle.ccDatePickerDay,
    'cc-DatePicker__anchor-btn': ccDatePickerStyle.ccDatePickerAnchorBtn,
    'cc-RangeDatePicker__anchor-btn': ccDatePickerStyle.ccRangeDatePickerAnchorBtn
  };
};
exports.useStyles = useStyles;
var _default = exports.default = useStyles;